/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/menu/MenuItem.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import { Item } from 'rc-menu';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import MenuContext from './MenuContext';
import { Tooltip } from '../tooltip';
import { SiderContext } from '../layout/Sider';
import { isValidElement, cloneElement } from '../_util/reactNode';
// @NOTE: to suppress the error TS4026 from './index.tsx': Public static property 'Item' of exported class has or is using name 'MenuItem' from external module
export class MenuItem extends React.Component {
    static contextType = MenuContext;
    renderItemChildren(inlineCollapsed) {
        const { prefixCls, firstLevel } = this.context;
        const { icon, children } = this.props;
        const wrapNode = React.createElement("span", { className: `${prefixCls}-title-content` }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || (isValidElement(children) && children.type === 'span')) {
            if (children && inlineCollapsed && firstLevel && typeof children === 'string') {
                return React.createElement("div", { className: `${prefixCls}-inline-collapsed-noicon` }, children.charAt(0));
            }
        }
        return wrapNode;
    }
    renderItem = ({ siderCollapsed }) => {
        const { prefixCls, firstLevel, inlineCollapsed, direction } = this.context;
        const { className, children } = this.props;
        const { title, icon, danger, ...rest } = this.props;
        let tooltipTitle = title;
        if (typeof title === 'undefined') {
            tooltipTitle = firstLevel ? children : '';
        }
        else if (title === false) {
            tooltipTitle = '';
        }
        const tooltipProps = {
            title: tooltipTitle
        };
        if (!siderCollapsed && !inlineCollapsed) {
            tooltipProps.title = null;
            // Reset `visible` to fix control mode tooltip display not correct
            // ref: https://github.com/ant-design/ant-design/issues/16742
            tooltipProps.visible = false;
        }
        const childrenLength = toArray(children).length;
        return (React.createElement(Tooltip, { ...tooltipProps, placement: direction === 'rtl' ? 'left' : 'right', overlayClassName: `${prefixCls}-inline-collapsed-tooltip` },
            React.createElement(Item, { ...rest, className: classNames({
                    [`${prefixCls}-item-danger`]: danger,
                    [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
                }, className), title: typeof title === 'string' ? title : undefined },
                cloneElement(icon, {
                    className: classNames(isValidElement(icon) ? icon.props?.className : '', `${prefixCls}-item-icon`)
                }),
                this.renderItemChildren(inlineCollapsed))));
    };
    render() {
        return React.createElement(SiderContext.Consumer, null, this.renderItem);
    }
}
// export default withConfigProvider(MenuItem);
export default MenuItem;
